module.exports = __webpack_public_path__ + "img/06_new2017_temp.428f2957.png";